// Device-only state for the "What we need from you" card (C8, P-f): which
// prompts are ticked and whether the card is collapsed. Never sent anywhere.
//
// Keyed per script and per round (status), so a new round starts unticked.
// Ticks are stored as a hash of the prompt's wording, so an edited prompt
// shows unticked rather than inheriting a tick meant for different words.

export interface ChecklistDeviceState {
  collapsed: boolean;
  ticked: string[];
}

export function checklistStorageKey(slug: string, status: string): string {
  return `hsp_checklist_${slug}_${status}`;
}

/** FNV-1a, 32-bit, hex. Short and stable; collisions only cost a stray tick. */
export function promptKey(prompt: string): string {
  let hash = 0x811c9dc5;
  for (let i = 0; i < prompt.length; i++) {
    hash ^= prompt.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
}

export function readChecklistState(key: string): ChecklistDeviceState {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return { collapsed: false, ticked: [] };
    const parsed = JSON.parse(raw) as Partial<ChecklistDeviceState>;
    return {
      collapsed: parsed.collapsed === true,
      ticked: Array.isArray(parsed.ticked) ? parsed.ticked.filter((t) => typeof t === 'string') : [],
    };
  } catch {
    return { collapsed: false, ticked: [] };
  }
}

export function writeChecklistState(key: string, state: ChecklistDeviceState): void {
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch {}
}
